// components/ViewLogsModal.jsx
import React from 'react';

const ViewLogsModal = ({ isOpen, onClose, logs }) => {
  // Sample logs data - in a real app this would come from props or API
  const sampleLogs = [
    {
      id: 1,
      action: 'Added',
      item: 'Bath Towels',
      quantity: 50,
      user: 'Admin',
      timestamp: '2023-05-15 10:30',
    },
    {
      id: 2,
      action: 'Adjusted',
      item: 'Shampoo',
      quantity: -12,
      user: 'Housekeeping',
      timestamp: '2023-05-15 09:15',
    },
    {
      id: 3,
      action: 'Restocked',
      item: 'Coffee Pods',
      quantity: 100,
      user: 'Manager',
      timestamp: '2023-05-14 16:45',
    },
    {
      id: 4,
      action: 'Damaged',
      item: 'Hand Towels',
      quantity: -3,
      user: 'Staff',
      timestamp: '2023-05-14 14:20',
    },
    {
      id: 5,
      action: 'Added',
      item: 'Bathrobes',
      quantity: 20,
      user: 'Admin',
      timestamp: '2023-05-13 11:10',
    },
  ];

  const displayedLogs = logs || sampleLogs;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold text-gray-900">Inventory Activity Logs</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="mt-2 flex items-center space-x-4">
            <div className="flex-1">
              <input
                type="text"
                placeholder="Search logs..."
                className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <select className="border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500">
              <option>All Actions</option>
              <option>Added</option>
              <option>Adjusted</option>
              <option>Restocked</option>
              <option>Damaged</option>
            </select>
            <select className="border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500">
              <option>Last 7 Days</option>
              <option>Today</option>
              <option>Last 30 Days</option>
              <option>All Time</option>
            </select>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Action
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Item
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  User
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Timestamp
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {displayedLogs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        log.action === 'Added' || log.action === 'Restocked'
                          ? 'bg-green-100 text-green-800'
                          : log.action === 'Damaged'
                            ? 'bg-red-100 text-red-800'
                            : 'bg-yellow-100 text-yellow-800'
                      }`}
                    >
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{log.item}</td>
                  <td className="text-black">
                    {log.quantity > 0 ? `+${log.quantity}` : log.quantity}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{log.user}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {log.timestamp}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-between items-center bg-gray-50">
          <div className="text-sm text-gray-500">
            Showing 1 to {displayedLogs.length} of {displayedLogs.length} entries
          </div>
          <div className="flex space-x-2">
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
              Previous
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewLogsModal;
